import React from 'react'
import pt from 'prop-types'

import LinkWithLogin from '../../LinkWithLogin'

import ProfileIcon from '../../icon/Man'

const isProfile = ({ username, pathname }) => {
  return (
    pathname.includes(`/@${username}`) ||
    (pathname.includes('privacy') && username) ||
    (pathname.includes('tos') && username)
  )
}

const Profile = ({ pathname, username }) => {
  const isActive = isProfile({ username, pathname })

  return (
    <LinkWithLogin
      className={'main-menu-item main-menu-item--profile ' + (isActive && 'main-menu-item--active')}
      to={username ? '/' + '@' + username : null}
    >
      <ProfileIcon />
    </LinkWithLogin>
  )
}

Profile.propTypes = {
  pathname: pt.string,
  username: pt.string
}

export default Profile
